import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import colors from 'components/PortfolioTables/colors';
import { EdwardColors } from 'enums';
import { borderRadiusBox } from 'components/AppTheme/index';

const useTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridFix: {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        margin: 0,
      },
    },
    dialog: {
      paddingTop: 0,
      [theme.breakpoints.down('md')]: {
        padding: 0,
      },
    },
    categories: {
      display: 'flex',
      alignItems: 'stretch',
      marginBottom: '28px',

      '& > ul > li': { margin: '0 0 0 8px' },
      '& ul': {
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        width: '100%',
        padding: 0,
      },

      '& li': {
        borderRadius: theme.spacing(1),
        background: EdwardColors.GRAY_LIGHT,
        color: '#fff',
        margin: theme.spacing(0.5),
        lineHeight: '1',
        minHeight: '40px',
        display: 'inline-flex',
        textTransform: 'uppercase',
        padding: '6px 16px',
        whiteSpace: 'wrap',
        '&.selected.IK1': { backgroundColor: colors['IK1'] },
        '&.selected.IK2': { backgroundColor: colors['IK2'] },
        '&.selected.IK3': { backgroundColor: colors['IK3'] },
        '&.selected.IK4': { backgroundColor: colors['IK4'] },
        '&.selected.IK5': { backgroundColor: colors['IK5'] },
        '&:hover': {
          backgroundColor: EdwardColors.GRAY_MEDIUM,
          color: '#fff',
        },
        '& div': {
          margin: 0,
          '& span': {
            fontSize: '14px',
            fontWeight: 500,
            marginTop: '-3px',
          },
        },
      },
      '& svg': {
        width: '2em',
        height: '2em',
        color: '#fff',
        marginTop: '-0.66em',
      },
    },
    pie: {
      marginBottom: '30px',
    },
    section: {
      zIndex: 1,
      padding: `${theme.spacing(4, 8)} !important`,
      justifyContent: 'center',
      margin: '0 !important',

      '&:first-child': {
        paddingRight: `40px !important`,
      },
      '&:last-child': {
        paddingLeft: `40px !important`,
      },

      '& > div': {
        padding: `0 !important`,
        '&.sectionBuffer': {
          paddingTop: '60px !important',
        },
      },

      [theme.breakpoints.down('md')]: {
        padding: `${theme.spacing(4, 3)} !important`,
        width: '100%',
        margin: 0,
        '&:last-child': {
          paddingLeft: `8px !important`,
        },
      },
    },
    ter: {
      paddingLeft: theme.spacing(4),
      '@media (max-width:1110px)': {
        paddingLeft: 0,
      },
    },
    wrapper: {
      position: 'relative',
      '& .MuiCircularProgress-root': {
        position: 'absolute',
        left: '50%',
        top: '50%',
      },
      '& h4': {
        marginBottom: theme.spacing(2),
      },
      '& > div': {
        marginBottom: '80px',
      },
    },
    title: {
      alignContent: 'center',
      minHeight: theme.spacing(10),
      margin: 0,
      justifyContent: 'center',
      '& .MuiTypography-h2': {
        marginBottom: 0,
        fontSize: '28px',
        fontWeight: 900,
      },
      '& button': {
        marginLeft: theme.spacing(1),
        '& svg': { color: EdwardColors.SECONDARY },
      },
    },
    table: {
      '& div[class^=MuiToolbar-root]': {
        padding: theme.spacing(0, 0.5),
        '& > div:first-child': { display: 'none' },
        '& div[class^=MuiFormControl-root]': {
          maxWidth: '100%',
          paddingLeft: 0,
        },
        '& *:not([class*=MuiTableRow-footer]) div[class^=MuiInputBase-root]': {
          background: '#f5f5f5',
          height: theme.spacing(5),
          borderRadius: theme.spacing(1),
        },
      },
      '& th, & tr:not([class*=MuiTableRow-footer]) td:not([class*="MuiTableCell-paddingNone"])': {
        color: '#000 !important',
        padding: theme.spacing(1),
      },
      '& tr:not(.MuiTableRow-footer) td:first-child, & tr:not([class*=MuiTableRow-footer]) td:first-child button': {
        color: 'inherit !important',
      },
      '& tr:not([class*=MuiTableRow-footer]) td:last-child button': {
        background: EdwardColors.DARKER,
        color: '#000',
        '&:hover': {
          background: EdwardColors.MEDIUM,
        },
      },
      '& div[class*=MuiTablePagination-toolbar]': {
        justifyContent: 'end',
      },
      '& td:first-child button[class*=MuiButtonBase-root]': {
        transform: `rotate(90deg) !important`,
      },
      '& td:first-child button[style*=rotate] ': {
        transform: `rotate(-90deg) !important`,
      },
    },
    actions: {
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      minHeight: '110px',
      '& > div': {
        width: '25%',
      },
      '& > div:first-child, & > div:last-child': {
        width: '40%',
      },
      '& > div:first-child': {
        paddingLeft: theme.spacing(10),
        [theme.breakpoints.down('md')]: {
          paddingLeft: theme.spacing(3),
        },
        '& > span, & > strong': {
          display: 'block',
        },
      },
      '& div:nth-child(2)': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& button': {
        margin: theme.spacing(0, 1),
      },
    },
    altActions: {
      width: '100% !important',
      marginTop: theme.spacing(1),
      display: 'flex',
      justifyContent: 'center'
    },
    infoSum: {
      fontSize: '18px',
      fontWeight: 900,
      lineHeight: '32px',
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
      },
      '& strong': {
        fontSize: '22px',
        borderStyle: 'solid',
        borderWidth: `2px`,
        borderRadius: borderRadiusBox,
        padding: theme.spacing(0.5),
        [theme.breakpoints.down('md')]: {
          fontSize: '19px',
        },
      },
    },
  }),
);

export default useTableStyles;
